import { CANONICALLS_AMBIENT_CAPTURE, CANONICALLS_AMBIENT_NOTE } from "../../lib/canonicallsCopy";

export function AmbientCanonicalization({ variant = "footer" }: { variant?: "footer" | "inline" }) {
  return (
    <aside
      className={`canonicalls-ambient canonicalls-ambient--${variant}`}
      aria-label="Future canonicalization surfaces"
    >
      <p className="canonicalls-ambient__label">Canonicalize from anywhere</p>
      <ul className="canonicalls-ambient__list">
        {CANONICALLS_AMBIENT_CAPTURE.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
      <p className="canonicalls-ambient__note">{CANONICALLS_AMBIENT_NOTE}</p>
    </aside>
  );
}
